export default "__VITE_ASSET__c7361f70__"